<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1>UPDATE STREAM DETAILS</h1>
      </div>
      <div class="form-modal-body">
        <b-field label="Title">
          <b-input v-model="form.title" value="Kevin Garvey"></b-input>
        </b-field>

        <b-field label="Event cover image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image"
            @onFileSelected="onImageSelected">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <b-field label="Description">
          <b-input v-model="form.description" maxlength="600" type="textarea"></b-input>
        </b-field>
        <b-field label="Start Time (Use Rwandan Time)">
          <b-datetimepicker v-model="selected_date" placeholder="Click to select..." icon="calendar-today"
            :icon-right="selected_date ? 'close-circle' : ''" icon-right-clickable @icon-right-click="clearDateTime"
            :locale="locale" :first-day-of-week="firstDayOfWeek" :datepicker="{ showWeekNumber }"
            :timepicker="{ enableSeconds, hourFormat }" horizontal-time-picker position="is-top-right">
          </b-datetimepicker>
        </b-field>
        <b-field label="Status">
          <b-select placeholder="Select status" v-model="form.visibility">
            <option v-for="option in streamVisibilityOptions" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="updateStream" type="is-primary">UPDATE</b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {
  },
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    selected_date: new Date(),
    isModalActive: true,
    showWeekNumber: false,
    enableSeconds: false,
    hourFormat: undefined, // Browser locale
    locale: undefined, // Browser locale
    firstDayOfWeek: undefined, // 0 - Sunday
    streamVisibilityOptions: [
      {
        value: 'Public',
        label: 'Public'
      },
      {
        value: 'Private',
        label: 'Private'
      },
      {
        value: 'Preview',
        label: 'Preview'
      },
      {
        value: 'Unlisted',
        label: 'Unlisted'
      },
    ],
    form: {
      id: null,
      title: "",
      image: "",
      description: "",
      start_date: new Date(),
      visibility: 'Public',
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.stream) {
      vm.setFormFields();
    } else {
      vm.resetForm();
    }
  },
  methods: {
    clearDateTime() {
      this.selected = null;
    },
    setFormFields() {
      let vm = this;
      vm.form.id = vm.stream.id;
      vm.form.title = vm.stream.title;
      vm.form.description = vm.stream.description;
      vm.form.start_date = vm.stream.start_date;
      vm.form.image = vm.stream.image;
      vm.form.visibility = vm.stream.visibility;
      if (!vm.form.start_date || (vm.form.start_date && vm.form.start_date.startsWith("0000"))) {
        vm.selected_date = null;
      } else {
        vm.selected_date = vm.stream.start_date
          ? vm.moment(vm.stream.start_date).toDate()
          : null;
      }
    },
    resetForm() {
      let vm = this;
      vm.form.id = null;
      vm.form.title = "";
      vm.form.description = "";
      vm.form.start_date = new Date();
      vm.form.image = "";
      vm.selected_date = new Date();
      vm.form.visibility = 'Public';
    },
    updateStream() {
      let vm = this;
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Title is required";
            }
            return false;
          },
        },
        description: {
          run: (value) => {
            if (!value) {
              return "Description is required";
            }
            return false;
          },
        },
        start_date: {
          run: (value) => {
            if (!vm.selected_date) {
              return "Start date is required";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.id = vm.stream.id;
        vm.form.start_date = vm
          .moment(vm.selected_date)
          .format("YYYY-MM-DD HH:mm:ss");
        vm.$store
          .dispatch("STREAMING_UPDATE_STREAM", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$emit("saved", response.data.return);
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
